<section class="caso-dictamen container py-3">
  <h3 *ngIf="id && !expediente">Caso: {{ id }}</h3>

  <!-- Detalles del Expediente e Institución -->
  <div class="row mb-4" *ngIf="expediente">
    <div class="col-md-6">
      <div class="card h-100">
        <div class="card-header bg-light">
          <h6 class="mb-0">Detalles del Funcionario</h6>
        </div>
        <div class="card-body">
          <p class="mb-1"><strong>Nombre:</strong> {{ expediente.exp_nombre_fun }} {{
            expediente.exp_apellido_paterno_fun }} {{ expediente.exp_apellido_materno_fun }}</p>
          <p class="mb-1"><strong>RUT:</strong> {{ expediente.exp_rut_fun }}</p>
          <p class="mb-1"><strong>ID Expediente:</strong> {{ expediente.exp_id }}</p>
          <p class="mb-1"><strong>Estado Actual:</strong> <span class="badge badge-primary">{{ expediente.eex_nombre
              }}</span></p>
          <p class="mb-1"><strong>Fecha Ingreso:</strong> {{ expediente.exp_fecha_ingreso | date:'dd/MM/yyyy' }}</p>
          <p class="mb-0" *ngIf="expediente.exp_observaciones"><strong>Observaciones:</strong> {{
            expediente.exp_observaciones }}</p>
        </div>
      </div>
    </div>

    <div class="col-md-6" *ngIf="institucion">
      <div class="card h-100">
        <div class="card-header bg-light">
          <h6 class="mb-0">Institución Solicitante</h6>
        </div>
        <div class="card-body">
          <p class="mb-1"><strong>Nombre:</strong> {{ institucion.ins_nombre }}</p>
          <p class="mb-1"><strong>RUT:</strong> {{ institucion.ins_rut }}</p>
          <p class="mb-1"><strong>Email Notificación:</strong> {{ institucion.ins_correo_notificacion }}</p>
          <p class="mb-0"><strong>Dirección:</strong> {{ institucion.ins_direccion }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Mostrar siempre los documentos asociados si existen -->
  <div *ngIf="documentos && documentos.length > 0" class="mb-3">
    <h6>Documentos asociados</h6>
    <ul class="list-group">
      <li *ngFor="let d of documentos" class="list-group-item d-flex justify-content-between align-items-center">
        <div>
          <div>{{ d.name }}</div>
          <small class="text-muted" *ngIf="d.type === 'zip'">(Este archivo es un ZIP — debe descargarse para ver su
            contenido)</small>
        </div>
        <div>
          <button *ngIf="d.type === 'pdf'" class="btn btn-sm btn-secondary" (click)="viewDocumento(d)">Ver</button>
          <button *ngIf="d.type === 'zip'" class="btn btn-sm btn-outline-secondary"
            (click)="viewDocumento(d)">Descargar</button>
        </div>
      </li>
    </ul>
  </div>

  <!-- Historial / Trazabilidad simplificada -->
  <div class="mb-4">
    <h6>Historial del Caso</h6>
    <div *ngIf="isLoading" class="text-center py-2">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      <span class="ml-2">Cargando historial...</span>
    </div>
    <div *ngIf="!isLoading && eventos.length > 0" class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead class="thead-light">
          <tr>
            <th>Fecha</th>
            <th>Tipo</th>
            <th>Usuario</th>
            <th>Descripción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of eventos">
            <td>{{ e.fecha | date:'dd/MM/yyyy HH:mm' }}</td>
            <td><span class="badge badge-info">{{ e.tipo }}</span></td>
            <td>{{ e.usuario }}</td>
            <td>{{ e.descripcion }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!isLoading && eventos.length === 0" class="text-muted small">
      No hay eventos registrados.
    </div>
  </div>

  <div *ngIf="hasDictamen; else noDictamen">
    <div class="card mb-3">
      <div class="card-body">
        <h5 class="card-title">Dictamen existente</h5>
        <p *ngIf="dictamen.fecha"><strong>Fecha:</strong> {{ dictamen.fecha }}</p>
        <p *ngIf="dictamen.medico"><strong>Médico:</strong> {{ dictamen.medico }}</p>
        <p *ngIf="dictamen.decision"><strong>Decisión:</strong> {{ dictamen.decision }}</p>
        <p *ngIf="dictamen.criterios"><strong>Criterios:</strong> {{ dictamen.criterios }}</p>
        <p *ngIf="dictamen.recomendaciones"><strong>Recomendaciones:</strong> {{ dictamen.recomendaciones }}</p>
      </div>
    </div>

    <div class="card" *ngIf="!isReadOnly">
      <div class="card-body">
        <h5 class="card-title">Actualizar decisión</h5>
        <form [formGroup]="form" (ngSubmit)="saveDecision()">
          <div class="form-group mb-2">
            <label>Decisión</label>
            <select class="form-control" formControlName="decision">
              <option value="Recuperable">Recuperable</option>
              <option value="Irrecuperable">Irrecuperable</option>
            </select>
          </div>
          <div class="form-group mb-2">
            <label>Observaciones</label>
            <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
          </div>
          <button class="btn btn-primary" type="submit">Guardar decisión</button>
        </form>
      </div>
    </div>
  </div>

  <!-- Emitir Resolución -->
  <div *ngIf="canEmitirResolucion" class="mb-4">
    <button class="btn btn-success" [disabled]="resolucionDisabled || isLoading"
      (click)="emitirResolucion()">
      <i class="bi bi-file-earmark-check"></i> Emitir resolución
    </button>
  </div>

  <ng-template #noDictamen>
    <div *ngIf="!isReadOnly">
      <form [formGroup]="form" (ngSubmit)="saveDecision()">
        <div class="form-group mb-2">
          <label>Decisión</label>
          <select class="form-control" formControlName="decision">
            <option value="">-- Seleccione --</option>
            <option value="Recuperable">Recuperable</option>
            <option value="Irrecuperable">Irrecuperable</option>
          </select>
        </div>
        <div class="form-group mb-2">
          <label>Observaciones</label>
          <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
        </div>
        <button class="btn btn-primary" type="submit">Registrar dictamen</button>
      </form>
    </div>
    <div *ngIf="isReadOnly" class="alert alert-info">
      El dictamen ya ha sido procesado o el caso se encuentra en estado de solo lectura.
    </div>
  </ng-template>
</section>